/**
 * Guards the post-login ``returnTo`` deep link against open-redirect abuse.
 *
 * ``returnTo`` is round-tripped through Auth0 ``appState`` (outside our trust
 * boundary) before being handed to React Router's ``navigate``. We only honor
 * internal absolute paths: a single leading "/" that is not followed by another
 * "/" or a "\". This rejects protocol-relative ("//evil.com") and backslash
 * ("/\evil.com") payloads that browsers may treat as external hosts.
 *
 * Browsers remove ASCII tab/newline/CR anywhere in a URL and trim leading/
 * trailing whitespace when parsing it (WHATWG URL). We mirror that normalization
 * before validating so a value like "/\t//evil.com" cannot slip past the guard
 * here and then collapse to a protocol-relative "///evil.com" once ``navigate``
 * hands it to ``history.pushState``.
 *
 * See OWASP Unvalidated Redirects and Forwards Cheat Sheet.
 */
export const isInternalReturnTo = (returnTo: unknown): returnTo is string => {
  if (typeof returnTo !== 'string') return false
  const normalized = returnTo.replace(/[\t\n\r]/g, '').trim()
  return /^\/(?![/\\])/.test(normalized)
}
